var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { width, height, space, borderRadius, boxShadow } from 'styled-system';
import { borderRadiusAttrs, borderRadiusValues, boxShadowAttrs, boxShadowSizeValues, paletteFamilies, roundedValues, } from '../utils';
var propTypes = __assign(__assign(__assign(__assign(__assign(__assign({}, borderRadius.propTypes), boxShadow.propTypes), height.propTypes), space.propTypes), width.propTypes), { borderRadiusSize: PropTypes.oneOf(borderRadiusValues), rounded: PropTypes.oneOf(roundedValues), boxShadowSize: PropTypes.oneOf(boxShadowSizeValues), boxShadowColor: PropTypes.oneOf(paletteFamilies) });
var Image = styled.img.attrs(function (props) { return (__assign(__assign({}, borderRadiusAttrs(props)), boxShadowAttrs(props))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  max-width: 100%;\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n"], ["\n  display: block;\n  max-width: 100%;\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n"])), height, space, width, borderRadius, boxShadow);
Image.displayName = 'Image';
Image.propTypes = propTypes;
export default Image;
var templateObject_1;
//# sourceMappingURL=Image.js.map